
import React, { useState, useEffect } from 'react';
import { JUVButton } from '@/components/juv';
import { Sparkle, X } from 'lucide-react';
import { cn } from '@/lib/utils';

const MembershipBenefitsCard = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  if (isDismissed) return null;

  return (
    <div
      className={cn(
        'fixed bottom-6 right-6 z-50 transition-all duration-500 ease-out',
        'max-w-sm w-full md:w-80',
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'
      )}
    >
      <div className="glass-panel p-6 relative">
        {/* Dismiss Button */}
        <button
          onClick={() => setIsDismissed(true)}
          className="absolute top-3 right-3 p-1 rounded-full hover:bg-juv-rose-clay/20 transition-colors"
        >
          <X className="h-4 w-4 text-juv-deep-chestnut/60" />
        </button>

        {/* Header */}
        <div className="flex items-center gap-3 mb-4">
          <Sparkle className="h-6 w-6 text-juv-terracotta" />
          <h3 className="text-lg font-semibold text-juv-deep-chestnut">
            What's Included in Your Membership
          </h3>
        </div>

        {/* Membership Price */}
        <div className="text-center mb-4">
          <span className="text-2xl font-bold text-juv-terracotta">$99</span>
          <span className="text-juv-deep-chestnut/70">/month</span>
        </div>

        {/* Benefits List */}
        <div className="space-y-3 mb-6">
          {[
            '✅ 4 professional cleanings per year',
            '✨ Advanced whitening treatment',
            '💸 Member pricing on all glow services',
            '🎁 Free birthday booster (whitening or skin)',
            '🚀 Priority scheduling + exclusive offers'
          ].map((benefit, index) => (
            <div key={index} className="flex items-start gap-2">
              <span className="text-sm text-juv-deep-chestnut/80 leading-relaxed">
                {benefit}
              </span>
            </div>
          ))}
        </div>

        {/* Join Button */}
        <JUVButton
          variant="primary"
          className="w-full"
          onClick={() => window.open('/membership', '_blank')}
        >
          Join Now
        </JUVButton>

        {/* Subtle glow effect */}
        <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-juv-terracotta/10 to-juv-rose-clay/10 -z-10 blur-xl" />
      </div>
    </div>
  );
};

export default MembershipBenefitsCard;
